import styled from "styled-components";

export const CustomButton = styled.p`
	padding: 6px;
	background-image: linear-gradient(to right, var(--tqColor), var(--darkBlue));
	color: ${(props) => (props.textColor ? props.textColor : "var(--mainWhite)")};
	border-radius: 10px;
	text-align: center;
	&:hover {
		cursor: pointer;
		background-image: linear-gradient(
			to right,
			var(--darkBlue),
			var(--mainWhite)
		);
	}
	@media (max-width: 962px) {
		boder-radius: 6px;
		font-size: 8px;
	}
`;
export const SmallButton = styled.button`
	padding-left: 35px;
	padding-right: 35px;
	padding-bottom: 8px;
	padding-top: 8px;
	border-color: white;
	background-image: linear-gradient(to right, var(--tqColor), var(--darkBlue));
	color: ${(props) => (props.textColor ? props.textColor : "var(--mainWhite)")};
	border-radius: 10px;
	text-align: center;
	&:hover {
		cursor: pointer;
		background-image: linear-gradient(
			to right,
			var(--darkBlue),
			var(--mainWhite)
		);
	}
	@media (max-width: 962px) {
		padding-left: 50px;
		padding-right: 50px;
		padding-bottom: 8px;
		padding-top: 8px;
		boder-radius: 6px;
		font-size: 8px;
	}
`;

export const Divider = styled.div`
	border: 5px solid ${(props) => (props.color ? props.color : "var(--tqColor)")};
	width: 80px;
	margin-bottom: 18px;
	// color: ${(props) => (props.color ? props.color : "var(--tqColor)")};
`;

export const CustomCard = styled.section`
	.card {
		--card-gradient: rgba(0, 0, 0, 0.8);
		--card-gradient: #5e9ad9, #e271ad;
		// --card-gradient: tomato, orange;
		--card-blend-mode: overlay;
		// --card-blend-mode: multiply;

		background-color: #fff;
		border-radius: 0.5rem;
		box-shadow: 0.05rem 0.1rem 0.3rem -0.03rem rgba(0, 0, 0, 0.45);
		padding-bottom: 1rem;
		background-image: linear-gradient(
			var(--card-gradient),
			white max(9.5rem, 27vh)
		);
		overflow: hidden;

		img {
			border-radius: 0.5rem 0.5rem 0 0;
			width: 100%;
			object-fit: cover;
			// height: max(10rem, 25vh);
			max-height: max(10rem, 30vh);
			aspect-ratio: 4/3;
			mix-blend-mode: var(--card-blend-mode);
			// filter: grayscale(100);

			~ * {
				margin-left: 1rem;
				margin-right: 1rem;
			}
		}

		> :last-child {
			margin-bottom: 0;
		}

		&:hover,
		&:focus-within {
			--card-gradient: #24a9d5 max(8.5rem, 20vh);
		}
	}
`;
export const ClassBadge = styled.div`
	.hexagon {
		width: 100px;
		height: 57.735px;
		background: red;
		position: relative;
		&::before {
			content: "";
			position: absolute;
			top: -28.8675px;
			left: 0;
			width: 0;
			height: 0;
			border-left: 50px solid transparent;
			border-right: 50px solid transparent;
			border-bottom: 28.8675px solid red;
		}
		&::after {
			content: "";
			position: absolute;
			bottom: -28.8675px;
			left: 0;
			width: 0;
			height: 0;
			border-left: 50px solid transparent;
			border-right: 50px solid transparent;
			border-top: 28.8675px solid red;
		}
	}
`;
